<template>
  <div class="chart-group" :class="{ open: isOpen }">
    <slot></slot>
    <div class="buttons">
      <BtnMain
        :class="[
          {
            'open -plus': !isOpen,
            'close -minus': isOpen,
          },
        ]"
        @click="toggle"
      >
        {{ `${isOpen ? "閉じる" : "もっと見る"}` }}
      </BtnMain>
    </div>
  </div>
</template>

<script>
import BtnMain from "../button/BtnMain";
export default {
  name: "ChartGroup",
  components: { BtnMain },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggle: function () {
      // this.open = !this.open
      this.isOpen = !this.isOpen;
      // this.$emit('open', this.isOpen)
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.chart-group {
  > .buttons {
    padding-top: 20px;
    text-align: center;
    display: none;
    @include mq-up(md) {
      padding-top: 30px;
    }
  }
  &.toggle {
    :deep(.buttons) {
      display: block;
    }
  }
}
</style>
